const kansasRouter = {
  route: null,
  name: null,
  title: '堪萨斯血检',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont icon-jiemiansheji',
  isElementIcon: false,
  filePath: 'view/kansas/', // 文件路径
  order: null,
  inNav: true,
  children: [
    {
      title: '二维码管理',
      type: 'view',
      name: 'KansasQrcodeList',
      route: '/kansas/qrcode/list',
      filePath: 'view/kansas/qrcode/list.vue',
      inNav: true,
      icon: 'iconfont icon-jiemiansheji',
      isElementIcon: false,
    },
    // 芯片号管理
    {
      title: '芯片号管理',
      type: 'view',
      name: Symbol('center'),
      route: '/kansas/chiplist/index',
      filePath: 'view/kansas/chiplist/index.vue',
      inNav: true,
      icon: 'iconfont icon-add',
      permission: ['芯片号管理'],
    },
    // 堪萨斯芯片爬虫
    {
      title: '爬虫管理',
      type: 'view',
      name: Symbol('center'),
      route: '/kansas/kss-spider/index',
      filePath: 'view/kansas/kss-spider/index.vue',
      inNav: true,
      icon: 'iconfont icon-add',
      permission: ['爬虫管理'],
    },
  ],
}

export default kansasRouter
